import { render, staticRenderFns } from "./FormProductionType.vue?vue&type=template&id=57315e74&scoped=true&"
import script from "./FormProductionType.vue?vue&type=script&lang=js&"
export * from "./FormProductionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57315e74",
  null
  
)

export default component.exports